import Footer from '@/components/SharedFooter';

const LandingFooter = () => {
  return <Footer />;
};

export default LandingFooter;
